"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _styles = require("@mui/material/styles");
var _APIs = require("../../constants/APIs");
var _labelConsts = require("../../constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("../../logics/stringUtil"));
var _coreInfoBarActions = require("../../reducers/coreInfoBarActions");
var _CButton = _interopRequireDefault(require("../materials/CButton"));
var _CDialog = _interopRequireDefault(require("../materials/CDialog"));
var _CLabel = _interopRequireDefault(require("../materials/CLabel"));
var _DisplayField = _interopRequireDefault(require("../materials/DisplayField"));
var _ListIconButton = _interopRequireDefault(require("../materials/ListIconButton"));
var _SuggestBox = _interopRequireDefault(require("../materials/SuggestBox"));
var _CallAPI = require("../system/CallAPI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const SPACING = {
  header: 1,
  dialog: 2
};
const ButtonGrid = (0, _styles.styled)(_Grid.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    flexGrow: 0
  };
});
const LabelGrid = (0, _styles.styled)(_Grid.default)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    flexGrow: 100
  };
});

/**
 * 会社/組織選択部品
 * @prop {bool} displayLabel - 選択されている会社・組織名を表示するフラグ default:true
 * @prop {string} label - 選択されている会社・組織名 displayLabel=true時のみ必須
 * @prop {bool} labelInitialize - 選択されている会社・組織名を初期表示する default:false displayLabel=true時のみ有効
 * @prop {bool} [required] - 選択必須とするか（validateは行わない） default:false
 * @prop {string} [titleText] - 項目名表示テキスト（変更したい場合のみ）
 * @prop {string} [buttonText] - ボタン表示テキスト（変更したい場合のみ）
 * @prop {bool} [isIcon] - アイコンの場合はtrue、ボタンの場合はfalse default:false
 * @prop {string} [iconType] - アイコンタイプ（アイコンを使用する場合のみ）default:register
 * @prop {string} [kaishaCd] - 選択されている会社コード
 * @prop {string} [soshikiCd] - 選択されている組織コード
 * @prop {string} [bcmKaishaSoshikiCd] - 選択されているBCM会社組織コード
 * @prop {string} [exTarget] - 範囲指定の識別子
 * @prop {string} [kansaTgtNendo] - 監査対象年度
 * @prop {bool} [bcmSelect] - BCMの会社／組織を選択肢とするか default:false
 * @prop {bool} [lv2limit] - Lv2までの選択とするか default:false
 * @prop {bool} [parentLv2Required] - 親会社のLv2の選択を必須とするか default:false
 * @prop {bool} [lv2Required] - Lv2の選択を必須とするか default:false
 * @prop {bool} [lv4overCheck] - 組織レベル4以上の選択を必須とするか default:false
 * @prop {func} onChange - 変更ハンドラ<br/>
 * シグネチャ:({bcmKaishaSoshikiCd:string,kaishaCd:string,soshikiCd:string,kaishaNm:string,soshikiNm:string,soshikiNmFull:string,label:string})
 */
class SelectKaishaSoshiki extends _react.default.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    _defineProperty(this, "INIT_STATE", {
      isDialogOpen: false,
      lv1Items: [],
      lv2Items: [],
      lv3Items: [],
      lv4Items: [],
      lv5Items: [],
      setNone: {
        lv1: false,
        lv2: false,
        lv3: false,
        lv4: false,
        lv5: false
      }
    });
    /** 組織CD長(Lv2). */
    _defineProperty(this, "SOSHIKI_CD_LENGTH_LV2", 13);
    /** 組織CD長(Lv4). */
    _defineProperty(this, "SOSHIKI_CD_LENGTH_LV4", 27);
    /**
     * リスト作成
     */
    _defineProperty(this, "fetchSelects", function (autoSelect, kaishaCd, soshikiCd) {
      let callBack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      const {
        callAPI,
        exTarget
      } = _this.props;
      const createItems = list => {
        let res = [];
        if (Array.isArray(list)) {
          res = list;
        }
        return res;
      };
      if (_this.props.bcmSelect) {
        callAPI(_APIs.BCM_KAISHA_SOSHIKI_SEARCH, {
          exTarget,
          kaishaCd: kaishaCd,
          soshikiCd: soshikiCd
        }).then(response => {
          const tmp = {
            bcmKaishaSoshikiCd: response.data.selectedBcmKaishaSoshikiCd ? response.data.selectedBcmKaishaSoshikiCd : '',
            kaishaCd: response.data.selectedKaishaCd ? response.data.selectedKaishaCd : '',
            kaishaNm: response.data.selectedKaishaName ? response.data.selectedKaishaName : '',
            soshikiCd: response.data.selectedSoshikiCd ? response.data.selectedSoshikiCd : '',
            soshikiNm: '',
            soshikiNmFull: '',
            label: response.data.selectedName ? response.data.selectedName : ''
          };
          _this.setState({
            lv1Items: createItems(response.data.selects.lv1),
            lv2Items: createItems(response.data.selects.lv2),
            setNone: {
              lv1: true,
              lv2: true
            },
            tmpData: tmp
          }, () => {
            if (callBack) {
              _this.props.onChange && _this.props.onChange(tmp);
            }
          });
        });
      } else {
        callAPI(_APIs.KAISHA_SOSHIKI_SEARCH, {
          exTarget,
          kaishaCd: kaishaCd,
          soshikiCd: soshikiCd,
          autoSelect: autoSelect,
          kansaTgtNendo: _this.props.kansaTgtNendo ? _this.props.kansaTgtNendo : '',
          lv2limit: _this.props.lv2limit
        }).then(response => {
          const tmp = {
            bcmKaishaSoshikiCd: '',
            kaishaCd: response.data.selectedKaishaCd ? response.data.selectedKaishaCd : '',
            kaishaNm: response.data.selectedKaishaName ? response.data.selectedKaishaName : '',
            soshikiCd: response.data.selectedSoshikiCd ? response.data.selectedSoshikiCd : '',
            soshikiNm: response.data.selectedSoshikiNameLast ? response.data.selectedSoshikiNameLast : '',
            soshikiNmFull: response.data.selectedSoshikiNameFull ? response.data.selectedSoshikiNameFull : '',
            label: response.data.selectedName ? response.data.selectedName : ''
          };
          _this.setState({
            lv1Items: createItems(response.data.selects.lv1),
            lv2Items: createItems(response.data.selects.lv2),
            lv3Items: createItems(response.data.selects.lv3),
            lv4Items: createItems(response.data.selects.lv4),
            lv5Items: createItems(response.data.selects.lv5),
            setNone: response.data.bumonLv,
            tmpData: tmp
          }, () => {
            if (callBack) {
              _this.props.onChange && _this.props.onChange(tmp);
            }
          });
        });
      }
    });
    /** 会社リスト変更時イベント */
    _defineProperty(this, "onChangeKaisha", kaishaCd => {
      if (this.state.tmpData.kaishaCd === kaishaCd) {
        return;
      }
      if (!kaishaCd || this.props.lv2limit || this.props.kansaTgtNendo) {
        this.fetchSelects(false, kaishaCd, '');
      } else {
        this.fetchSelects(true, kaishaCd, '');
      }
    });
    /** 組織リスト変更時イベント */
    _defineProperty(this, "onChangeSoshiki", lv => soshikiCd => {
      // 基本的に自動選択ありで動く
      // 例外として、選択してくださいを選んだときは、その上位組織を選びたいと判断し、自動選択をなしとする

      // 「選択してください」は、上位組織コードの値のため、変更された組織Lvのマイナス１でスライス（Lv2は最上位組織なので、空文字）
      let noneValue = lv === 2 ? '' : _stringUtil.default.sliceSoshikiCd(soshikiCd, lv - 1);
      if (noneValue === soshikiCd || this.props.lv2limit || this.props.kansaTgtNendo) {
        this.fetchSelects(false, this.state.tmpData.kaishaCd, soshikiCd);
      } else {
        this.fetchSelects(true, this.state.tmpData.kaishaCd, soshikiCd);
      }
    });
    /** 選択中データを作成する */
    _defineProperty(this, "createTmpData", (kaishaCd, soshikiCd, bcmKaishaSoshikiCd) => {
      return {
        bcmKaishaSoshikiCd: bcmKaishaSoshikiCd ? bcmKaishaSoshikiCd : '',
        kaishaCd: kaishaCd ? kaishaCd : '',
        kaishaNm: '',
        soshikiCd: soshikiCd ? soshikiCd : '',
        soshikiNm: '',
        soshikiNmFull: '',
        label: ''
      };
    });
    /** 非活性を判定する */
    _defineProperty(this, "jadgeDisabled", (kaishacd, soshikiCd, bumonLv) => {
      switch (bumonLv) {
        case 1:
          return false;
        case 2:
          return !kaishacd;
        default:
          return !(String(soshikiCd).split('-', bumonLv).length >= bumonLv - 1);
      }
    });
    /** ダイアログを開くイベント */
    _defineProperty(this, "openDialog", () => {
      this.setState({
        isDialogOpen: true,
        tmpData: this.createTmpData(this.props.kaishaCd, this.props.soshikiCd, this.props.bcmKaishaSoshikiCd)
      });
      if (Array.isArray(this.state.lv1Items) && this.state.lv1Items.length === 0) {
        if (this.props.kansaTgtNendo) {
          this.fetchSelects(false, this.props.kaishaCd, this.props.soshikiCd);
        } else {
          this.fetchSelects(true, this.props.kaishaCd, this.props.soshikiCd);
        }
      }
    });
    /** ダイアログを閉じるイベント */
    _defineProperty(this, "closeDialog", () => {
      this.setState(_objectSpread({}, this.INIT_STATE));
    });
    /** 選択状態を更新するイベント */
    _defineProperty(this, "onUpdate", () => {
      if (this.props.required && !this.state.tmpData.kaishaCd) {
        this.props.openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, this.props.intl.formatMessage({
          id: _labelConsts.LABEL.CORE_KAISHA_SOSHIKI_SELECT_PLACEHOLDER
        }));
        return;
      }
      if (this.props.lv4overCheck && this.state.tmpData.soshikiCd.length < this.SOSHIKI_CD_LENGTH_LV4) {
        this.props.openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, this.props.intl.formatMessage({
          id: _labelConsts.LABEL.CORE_PLEASE_SELECT_SOSHIKI_LV4_OR_MORE
        }));
        return;
      }
      if ((this.props.bcmSelect || this.props.parentLv2Required) && this.state.tmpData.kaishaCd === this.props.systemSettings.core_parent_company_cd && !this.state.tmpData.soshikiCd) {
        this.props.openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, this.props.intl.formatMessage({
          id: _labelConsts.LABEL.CORE_SOSHIKI_SELECT_PLACEHOLDER
        }));
        return;
      }
      if (this.props.lv2Required && this.state.tmpData.soshikiCd.length < this.SOSHIKI_CD_LENGTH_LV2) {
        this.props.openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, this.props.intl.formatMessage({
          id: _labelConsts.LABEL.CORE_SOSHIKI_SELECT_PLACEHOLDER
        }));
        return;
      }

      // 呼び出し側へ選択結果を通知
      if (typeof this.props.onChange === 'function') {
        this.props.onChange(this.state.tmpData);
      }
      this.closeDialog();
    });
    _defineProperty(this, "cancelBtn", /*#__PURE__*/_react.default.createElement(_CButton.default, {
      autoWidth: true,
      negative: true,
      onClick: this.closeDialog
    }, this.props.intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CANCEL
    })));
    _defineProperty(this, "okBtn", /*#__PURE__*/_react.default.createElement(_CButton.default, {
      autoWidth: true,
      onClick: this.onUpdate
    }, this.props.intl.formatMessage({
      id: _labelConsts.LABEL.CORE_OK
    })));
    this.state = _objectSpread(_objectSpread({}, this.INIT_STATE), {}, {
      tmpData: {
        bcmKaishaSoshikiCd: '',
        kaishaCd: '',
        kaishaNm: '',
        soshikiCd: '',
        soshikiNm: '',
        soshikiNmFull: '',
        label: ''
      }
    });
  }
  componentDidMount() {
    const {
      kaishaCd,
      soshikiCd,
      bcmKaishaSoshikiCd,
      displayLabel,
      labelInitialize
    } = this.props;
    this.setState({
      tmpData: this.createTmpData(kaishaCd, soshikiCd, bcmKaishaSoshikiCd)
    });
    if (displayLabel && labelInitialize && kaishaCd && soshikiCd) {
      this.fetchSelects(true, kaishaCd, soshikiCd, true);
    }
  }
  render() {
    /** props */
    const {
      intl,
      className,
      displayLabel,
      label,
      required,
      titleText,
      buttonText,
      lv2limit,
      bcmSelect,
      isIcon,
      iconType,
      displayTitle,
      error,
      helperText
    } = this.props;
    const {
      isDialogOpen,
      tmpData,
      lv1Items,
      lv2Items,
      lv3Items,
      lv4Items,
      lv5Items,
      setNone
    } = this.state;
    const {
      kaishaCd,
      soshikiCd
    } = tmpData;
    const item = /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: SPACING.header
    }, /*#__PURE__*/_react.default.createElement(ButtonGrid, {
      size: {
        xs: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_CButton.default, {
      autoWidth: true,
      onClick: this.openDialog
    }, buttonText ? buttonText : intl.formatMessage({
      id: _labelConsts.LABEL.CORE_KAISHA_SOSHIKI_SELECT
    }))), /*#__PURE__*/_react.default.createElement(LabelGrid, {
      size: {
        xs: true
      }
    }, /*#__PURE__*/_react.default.createElement(_DisplayField.default, {
      placeholder: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_PLEASE_SELECT_REPLACE
      }, {
        0: titleText ? titleText : intl.formatMessage({
          id: _labelConsts.LABEL.CORE_KAISHA_SOSHIKI
        })
      }),
      error: !!error,
      helperText: helperText
    }, label ? label : '')));
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (() => {
      if (isIcon) {
        return /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
          action: iconType,
          onClick: this.openDialog
        });
      } else {
        if (displayLabel) {
          return displayTitle ? /*#__PURE__*/_react.default.createElement(_CLabel.default, {
            label: titleText ? titleText : this.props.intl.formatMessage({
              id: _labelConsts.LABEL.CORE_KAISHA_SOSHIKI
            }),
            required: required,
            className: className
          }, item) : item;
        } else {
          return /*#__PURE__*/_react.default.createElement(_CButton.default, {
            autoWidth: true,
            onClick: this.openDialog,
            className: className
          }, buttonText ? buttonText : intl.formatMessage({
            id: _labelConsts.LABEL.CORE_KAISHA_SOSHIKI_SELECT
          }));
        }
      }
    })(), /*#__PURE__*/_react.default.createElement(_CDialog.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_KAISHA_SOSHIKI_SELECT
      }),
      actions: [this.cancelBtn, this.okBtn],
      open: isDialogOpen,
      handleClose: this.closeDialog
    }, /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: SPACING.dialog
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      sx: {
        pt: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_SuggestBox.default, {
      value: kaishaCd,
      setNone: !required && setNone['lv1'],
      items: lv1Items,
      disabled: this.jadgeDisabled(kaishaCd, soshikiCd, 1),
      onChange: this.onChangeKaisha
    })), !((lv2limit || bcmSelect) && this.state.tmpData.kaishaCd && this.state.tmpData.kaishaCd !== this.props.systemSettings.core_parent_company_cd) && /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_SuggestBox.default, {
      value: _stringUtil.default.sliceSoshikiCd(soshikiCd, 2),
      noneValue: '',
      setNone: setNone['lv2'],
      items: lv2Items,
      disabled: this.jadgeDisabled(kaishaCd, soshikiCd, 2),
      onChange: this.onChangeSoshiki(2)
    })), !lv2limit && !bcmSelect && /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_SuggestBox.default, {
      value: _stringUtil.default.sliceSoshikiCd(soshikiCd, 3),
      noneValue: _stringUtil.default.sliceSoshikiCd(soshikiCd, 2),
      setNone: setNone['lv3'],
      items: lv3Items,
      disabled: this.jadgeDisabled(kaishaCd, soshikiCd, 3),
      onChange: this.onChangeSoshiki(3)
    })), !lv2limit && !bcmSelect && /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_SuggestBox.default, {
      value: _stringUtil.default.sliceSoshikiCd(soshikiCd, 4),
      noneValue: _stringUtil.default.sliceSoshikiCd(soshikiCd, 3),
      setNone: setNone['lv4'],
      items: lv4Items,
      disabled: this.jadgeDisabled(kaishaCd, soshikiCd, 4),
      onChange: this.onChangeSoshiki(4)
    })), !lv2limit && !bcmSelect && /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_SuggestBox.default, {
      value: _stringUtil.default.sliceSoshikiCd(soshikiCd, 5),
      noneValue: _stringUtil.default.sliceSoshikiCd(soshikiCd, 4),
      setNone: setNone['lv5'],
      items: lv5Items,
      disabled: this.jadgeDisabled(kaishaCd, soshikiCd, 5),
      onChange: this.onChangeSoshiki(5)
    }))))));
  }
}
SelectKaishaSoshiki.propTypes = {
  displayLabel: _propTypes.default.bool.isRequired,
  labelInitialize: _propTypes.default.bool,
  required: _propTypes.default.bool,
  validate: _propTypes.default.bool,
  label: _propTypes.default.string.isRequired,
  kaishaCd: _propTypes.default.string,
  soshikiCd: _propTypes.default.string,
  titleText: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  exTarget: _propTypes.default.string,
  bcmSelect: _propTypes.default.bool,
  lv2limit: _propTypes.default.bool,
  parentLv2Required: _propTypes.default.bool,
  lv2Required: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  isIcon: _propTypes.default.bool,
  iconType: _propTypes.default.string,
  lv4overCheck: _propTypes.default.bool,
  error: _propTypes.default.bool,
  helperText: _propTypes.default.node
};
SelectKaishaSoshiki.defaultProps = {
  displayLabel: true,
  labelInitialize: false,
  required: false,
  label: '',
  bcmSelect: false,
  lv2limit: false,
  parentLv2Required: false,
  lv2Required: false,
  lv4overCheck: false,
  isIcon: false,
  iconType: 'register',
  displayTitle: true
};
const mapStateToProps = state => {
  return {
    systemSettings: state.coreLoginInfo.systemSettings
  };
};
const mapDispatchToProps = dispatch => {
  return {
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(SelectKaishaSoshiki)));